import React, { useEffect, useState, useContext, useRef } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText, IonAlert, IonInput, IonIcon, IonLoading, IonButtons, IonModal, IonNote } from '@ionic/react';
import { useIonRouter, IonSlide, IonRow, IonCol, IonImg, IonRefresher, IonRefresherContent } from '@ionic/react';
import { Route, useHistory} from "react-router-dom";

import '../../css/layout.css';

import {
  informationCircleOutline,
  walletOutline,
  receiptOutline,
  cafeOutline,
  businessOutline,
  peopleOutline,
  cubeOutline,
  shieldCheckmarkOutline,
  idCardOutline,
  cloudUploadOutline,
  statsChartOutline,
  cashOutline
} from "ionicons/icons";

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { Hotel_PrivacyStatement } from './PrivacyStatement';



export function AboutModal (props) {


    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    let [schema, setSchemaName] = useState(authMerchant_objects.schema);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);
    //let [accounts_merchant, setAccounts_merchant ] = useState(authMerchant_objects.accounts_merchant);
    //let [accounts_user, setAccounts_user] = useState(authMerchant_objects.accounts_user);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);
    let [privacyStatementModal, setPrivacyStatementModal] = useState(false);


    return (
    <React.Fragment> 
        {props.openModal == true ?
            (
                <IonModal
                isOpen={props.openModal}
                onDidDismiss={props.onClose}
                >
                <IonHeader translucent>
                    <IonToolbar>
                        <IonTitle>ABOUT US</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonItem>
                    <IonText className='professional-text'>
                        GHANA VERIFIED - A Business management & payments platform for SMEs in Ghana.
                    </IonText>
                 </IonItem>
                <IonContent className="grid_content">
                    <IonList inset>
                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={walletOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>MoMo & Payments</h3>
                        <p>MTN MoMo integration, invoices with pay links, POS-style flows.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={receiptOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Invoicing & Billing</h3>
                        <p>Create invoices/receipts.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={cubeOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Inventory</h3>
                        <p>Track stock, costs, and pricing.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={cafeOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Hotel & Retail Modules</h3>
                        <p>Room/booking management and retail catalog with quick checkout.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={peopleOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Recruitment & Onboarding</h3>
                        <p>Post Jobs, Track Interview progress, Send Offer letters, Finalize Onboarding.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={idCardOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Employee Management</h3>
                        <p>Manage Employee roles, salaries, and user access controls.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={statsChartOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Analytics & Commissions</h3>
                        <p>YTD and multi-year reports, Payout tracking.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={cloudUploadOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Backups & Reliability</h3>
                        <p>PostgreSQL backups and tooling to keep your data safe.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="inset">
                        <IonIcon slot="start" icon={shieldCheckmarkOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Security</h3>
                        <p>Encrypted transport, access controls, and audit-friendly logs.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="none">
                        <IonIcon slot="start" icon={businessOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Built for Ghana</h3>
                        <p>Local currency (GHS), local workflows, and local support.</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem lines="none">
                        <IonIcon slot="start" icon={cashOutline} />
                        <IonLabel style={{ whiteSpace: 'normal' }}>
                        <h3>Cost and Fees</h3>
                        <p>Free sign-up For Customers.  Free sign-up for Merchants.  Merchants Only - 100 GHS per month after 50 invoices/transactions.</p>
                        </IonLabel>
                    </IonItem>
                    </IonList>

                    <div className="ion-padding-top">
                    <IonButton fill="clear" onClick={() => setPrivacyStatementModal(true)}> Privacy & Terms</IonButton>
                    <div className="ion-text-center ion-margin-top">
                        <IonNote>Version 1.0 • © ZSV Ghana</IonNote>
                    </div>
                    </div>

                   {privacyStatementModal == true && <Hotel_PrivacyStatement openModal={ privacyStatementModal } closeModal={() => setPrivacyStatementModal(false)} ></Hotel_PrivacyStatement>}

                </IonContent>

                <IonFooter className="grid_footer">
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonButton fill="solid" onClick={props.onClose}>Close</IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonFooter>
                </IonModal>
            ) : null}

    </React.Fragment>
    )
}

export default AboutModal;

